/**
 * Noirvere variant UI sync — cart ID, color labels, gallery, and Prestige product:rerender.
 * Build: 2026-06-04T7-anchor-gallery-filter
 */
(function () {
  'use strict';

  if (window.__nvProductVariantUiV2) return;
  window.__nvProductVariantUiV2 = true;

  var pendingByFormId = new Map();

  function variantIdInput(form) {
    if (!form) return null;
    return form.elements.namedItem('id') || form.querySelector('input[name="id"]');
  }

  function pickerForForm(form) {
    if (!form || !form.id) return null;
    return document.querySelector('variant-picker[form-id="' + form.id + '"]');
  }

  function formForPicker(picker) {
    var formId = picker && picker.getAttribute('form-id');
    return formId ? document.getElementById(formId) : null;
  }

  function galleryForForm(form) {
    if (!form || !form.id) return null;
    return document.querySelector('product-gallery[form="' + form.id + '"]');
  }

  function carouselForGallery(gallery) {
    if (!gallery) return null;
    return (
      gallery.querySelector('.product-gallery__carousel') ||
      gallery.querySelector('scroll-carousel') ||
      gallery.querySelector('media-carousel')
    );
  }

  function optionValueIds(picker) {
    return Array.from(picker.querySelectorAll('input[data-option-position]:checked'))
      .sort(function (a, b) {
        return (
          parseInt(a.getAttribute('data-option-position'), 10) -
          parseInt(b.getAttribute('data-option-position'), 10)
        );
      })
      .map(function (input) {
        return input.value;
      });
  }

  function variantFromPickerScript(picker) {
    var script = picker && picker.querySelector('script[data-variant]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function featuredMediaId(variant) {
    if (!variant) return null;
    var fm = variant.featured_media || variant.featured_image;
    return fm && fm.id ? fm.id : null;
  }

  function featuredMediaIdForForm(form, variant) {
    var picker = pickerForForm(form);
    if (picker) {
      var checked = picker.querySelector(
        'input[data-option-position]:checked[data-variant-media]'
      );
      if (!checked) {
        checked = picker.querySelector('input:checked[data-variant-media]');
      }
      if (checked) {
        var raw = checked.getAttribute('data-variant-media');
        if (raw) {
          try {
            var media = JSON.parse(raw);
            if (media && media.id) return String(media.id);
          } catch (e) {
            /* ignore */
          }
        }
      }
    }
    var fromVariant = featuredMediaId(variant);
    return fromVariant ? String(fromVariant) : null;
  }

  function hiddenIndexesFromAttr(filteredIndexesAttr) {
    var positions = [];
    try {
      positions = JSON.parse(filteredIndexesAttr || '[]');
    } catch (e) {
      positions = [];
    }
    return positions.map(function (position) {
      return parseInt(position, 10) - 1;
    });
  }

  function galleryAnchors(gallery) {
    if (!gallery) return [];
    var script = gallery.querySelector('script[data-nv-gallery-anchors]');
    if (!script) return [];
    try {
      var parsed = JSON.parse(script.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function variantAnchorPosition(anchors, variant) {
    if (!variant) return null;
    if (variant.featured_media && variant.featured_media.position) {
      return parseInt(variant.featured_media.position, 10);
    }
    var opts = [
      variant.option1,
      variant.option2,
      variant.option3,
      variant.options && variant.options[0],
      variant.options && variant.options[1],
      variant.options && variant.options[2]
    ];
    for (var i = 0; i < anchors.length; i++) {
      var anchor = anchors[i];
      var match = true;
      if (opts[0] != null && anchor.option1 != null && anchor.option1 !== opts[0]) match = false;
      if (opts[1] != null && anchor.option2 != null && anchor.option2 !== opts[1]) match = false;
      if (opts[2] != null && anchor.option3 != null && anchor.option3 !== opts[2]) match = false;
      if (match) return parseInt(anchor.position, 10);
    }
    return null;
  }

  function visibleMediaPositions(gallery, variant) {
    var anchors = galleryAnchors(gallery);
    if (!anchors.length || !variant) return null;

    var sorted = anchors
      .map(function (anchor) {
        return parseInt(anchor.position, 10);
      })
      .filter(function (position, index, list) {
        return !isNaN(position) && list.indexOf(position) === index;
      })
      .sort(function (a, b) {
        return a - b;
      });

    if (!sorted.length) return null;

    var start = variantAnchorPosition(anchors, variant);
    if (start == null || isNaN(start)) return null;

    var anchorIndex = sorted.indexOf(start);
    if (anchorIndex < 0) return null;

    var mediaCount = parseInt(gallery.getAttribute('data-nv-media-count') || '0', 10);
    if (!mediaCount) {
      var carousel = carouselForGallery(gallery);
      mediaCount = carousel && carousel.allCells ? carousel.allCells.length : sorted[sorted.length - 1];
    }

    var end =
      anchorIndex < sorted.length - 1 ? sorted[anchorIndex + 1] - 1 : mediaCount;
    var visible = [];
    for (var position = start; position <= end; position++) {
      visible.push(position);
    }
    return visible;
  }

  function filteredIndexesAttrForVariant(gallery, variant) {
    var visible = visibleMediaPositions(gallery, variant);
    if (!visible || !visible.length) return null;

    var mediaCount = parseInt(gallery.getAttribute('data-nv-media-count') || '0', 10);
    if (!mediaCount) {
      mediaCount = visible[visible.length - 1];
    }

    var hidden = [];
    for (var position = 1; position <= mediaCount; position++) {
      if (visible.indexOf(position) < 0) {
        hidden.push(position);
      }
    }
    return JSON.stringify(hidden);
  }

  function resolveFilteredIndexesAttr(gallery, filteredIndexesAttr, variant) {
    var serverHidden = [];
    try {
      serverHidden = JSON.parse(filteredIndexesAttr || '[]');
    } catch (e) {
      serverHidden = [];
    }

    if (serverHidden.length) {
      return filteredIndexesAttr;
    }

    var computed = filteredIndexesAttrForVariant(gallery, variant);
    return computed != null ? computed : filteredIndexesAttr;
  }

  function applyThumbnailFilterByIndex(gallery, hiddenIndexes) {
    if (!gallery || !hiddenIndexes) return;
    var thumbNav = gallery.querySelector('product-gallery-navigation[align-selected]');
    if (!thumbNav) return;
    var buttons = thumbNav.querySelectorAll('button');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].toggleAttribute('hidden', hiddenIndexes.indexOf(i) >= 0);
    }
  }

  function thumbnailScroller(thumbNav) {
    if (!thumbNav) return null;
    var list = thumbNav.closest('.product-gallery__thumbnail-list');
    if (list && list.scrollWidth > list.clientWidth + 1) return list;
    if (thumbNav.scrollWidth > thumbNav.clientWidth + 1) return thumbNav;
    return list || thumbNav;
  }

  function scrollThumbnailIntoView(thumbNav, match) {
    var scroller = thumbnailScroller(thumbNav);
    if (!scroller || !match) return;
    var maxLeft = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    var scrollerRect = scroller.getBoundingClientRect();
    var thumbRect = match.getBoundingClientRect();
    var targetLeft = Math.min(
      Math.max(
        0,
        scroller.scrollLeft +
          (thumbRect.left - scrollerRect.left) -
          scroller.clientWidth / 2 +
          match.clientWidth / 2
      ),
      maxLeft
    );
    scroller.scrollTo({ left: targetLeft, behavior: 'auto' });
    if (Math.abs(scroller.scrollLeft - targetLeft) > 2) {
      match.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'auto' });
    }
  }

  function syncThumbnailNavigation(gallery, mediaId, cellIndex) {
    var thumbNav = gallery.querySelector('product-gallery-navigation[align-selected]');
    if (!thumbNav || !thumbNav.items) return;

    var thumbIndex = -1;
    var match = null;

    if (mediaId != null) {
      for (var i = 0; i < thumbNav.items.length; i++) {
        if (String(thumbNav.items[i].getAttribute('data-media-id')) === String(mediaId)) {
          thumbIndex = i;
          match = thumbNav.items[i];
          break;
        }
      }
    }

    if (thumbIndex < 0 && typeof cellIndex === 'number' && cellIndex >= 0 && cellIndex < thumbNav.items.length) {
      thumbIndex = cellIndex;
      match = thumbNav.items[cellIndex];
    }

    if (thumbIndex < 0 || !match) return;

    for (var j = 0; j < thumbNav.items.length; j++) {
      thumbNav.items[j].setAttribute('aria-current', j === thumbIndex ? 'true' : 'false');
    }

    scrollThumbnailIntoView(thumbNav, match);
  }

  function updatePickerLabels(livePicker, sourcePicker) {
    if (!livePicker || !sourcePicker) return;
    var liveOptions = livePicker.querySelectorAll('.variant-picker__option');
    var sourceOptions = sourcePicker.querySelectorAll('.variant-picker__option');
    liveOptions.forEach(function (liveOption, index) {
      var sourceOption = sourceOptions[index];
      if (!sourceOption) return;
      var sourceSpan = sourceOption.querySelector('.variant-picker__option-info .h-stack span');
      var liveSpan = liveOption.querySelector('.variant-picker__option-info .h-stack span');
      if (sourceSpan && liveSpan) {
        liveSpan.textContent = sourceSpan.textContent;
      }
    });
  }

  function applyFilteredIndexes(gallery, filteredIndexesAttr, variant) {
    if (!gallery) return;
    var resolvedAttr = resolveFilteredIndexesAttr(gallery, filteredIndexesAttr, variant);
    if (resolvedAttr == null) return;
    var carousel = carouselForGallery(gallery);
    if (!carousel || typeof carousel.filter !== 'function') return;
    var hiddenIndexes = hiddenIndexesFromAttr(resolvedAttr);
    carousel.filter(hiddenIndexes);
    gallery.setAttribute('filtered-indexes', resolvedAttr);
    applyThumbnailFilterByIndex(gallery, hiddenIndexes);
  }

  window.__nvApplyGalleryFilteredIndexes = applyFilteredIndexes;

  function refreshGalleryFilters(form, picker) {
    if (!form || !picker) return Promise.resolve(null);
    return fetchVariantSection(picker).then(function (parsed) {
      var gallery = galleryForForm(form);
      if (gallery && parsed && parsed.galleryMarkup) {
        applyFilteredIndexes(
          gallery,
          parsed.galleryMarkup.getAttribute('filtered-indexes'),
          parsed.variant
        );
      }
      return parsed;
    });
  }

  function syncDiamondMediaGallery(form, variant) {
    if (!form || !variant || !variant.id) return;
    var gallery = galleryForForm(form);
    if (!gallery || !gallery.querySelector('.diamond-media__image-wrapper')) return;
    var id = String(variant.id);
    gallery.querySelectorAll('.diamond-media__image-wrapper').forEach(function (el) {
      var match = el.getAttribute('data-id') === id;
      el.classList.toggle('inactive', !match);
      el.classList.toggle('swiper-slide', match);
    });
    var container = gallery.querySelector('.swiper-container-media');
    var swiperInstance = container && container.swiper;
    if (swiperInstance) {
      swiperInstance.update();
      swiperInstance.slideTo(0, 0);
    }
  }

  function carouselIndexForMediaId(carousel, mediaId) {
    if (!carousel || mediaId == null) return -1;
    var id = String(mediaId);
    var cells = carousel.cells || [];
    for (var i = 0; i < cells.length; i++) {
      if (String(cells[i].getAttribute('data-media-id')) === id) {
        return i;
      }
    }
    if (carousel.allCells) {
      for (var j = 0; j < carousel.allCells.length; j++) {
        var cell = carousel.allCells[j];
        if (String(cell.getAttribute('data-media-id')) === id) {
          cell.removeAttribute('hidden');
          var visible = carousel.cells || [];
          for (var k = 0; k < visible.length; k++) {
            if (String(visible[k].getAttribute('data-media-id')) === id) {
              return k;
            }
          }
        }
      }
    }
    return -1;
  }

  function syncStandardProductGallery(form, variant) {
    if (!form || !variant) return;
    var gallery = galleryForForm(form);
    if (!gallery || gallery.querySelector('.diamond-media__image-wrapper')) return;

    var mediaId = featuredMediaIdForForm(form, variant);
    if (!mediaId) return;

    var carousel = carouselForGallery(gallery);
    var selectedIndex = -1;

    if (carousel && typeof carousel.select === 'function') {
      selectedIndex = carouselIndexForMediaId(carousel, mediaId);
      if (selectedIndex >= 0) {
        carousel.select(selectedIndex, { instant: true });
        syncThumbnailNavigation(gallery, mediaId, selectedIndex);
        return;
      }
      if (variant.featured_media && variant.featured_media.position) {
        var position = parseInt(variant.featured_media.position, 10) - 1;
        var hidden = [];
        try {
          hidden = JSON.parse(gallery.getAttribute('filtered-indexes') || '[]').map(function (p) {
            return parseInt(p, 10) - 1;
          });
        } catch (e) {
          hidden = [];
        }
        var hiddenBefore = hidden.filter(function (i) {
          return i < position;
        }).length;
        var posIndex = position - hiddenBefore;
        if (posIndex >= 0 && posIndex < carousel.cells.length) {
          carousel.select(posIndex, { instant: true });
          syncThumbnailNavigation(gallery, mediaId, posIndex);
          return;
        }
      }
    }

    var mediaEl =
      (carousel && carousel.querySelector('[data-media-id="' + mediaId + '"]')) ||
      gallery.querySelector('.product-gallery__media[data-media-id="' + mediaId + '"]');
    var cell = mediaEl && (mediaEl.closest('.product-gallery__media') || mediaEl);
    if (cell) {
      if (cell.hasAttribute('hidden')) cell.removeAttribute('hidden');
      cell.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'auto' });
      syncThumbnailNavigation(gallery, mediaId);
    }
  }

  function scheduleGallerySync(form, variant) {
    if (!form || !variant) return;
    function run() {
      syncProductGalleryMedia(form, variant);
    }
    run();
    requestAnimationFrame(function () {
      run();
      requestAnimationFrame(run);
    });
    setTimeout(run, 80);
    setTimeout(run, 220);
  }

  function bindGalleryCarouselSync(form) {
    var gallery = galleryForForm(form);
    if (!gallery || gallery.__nvThumbCarouselBound) return;
    gallery.__nvThumbCarouselBound = true;
    var carousel = carouselForGallery(gallery);
    if (!carousel) return;
    var onCarouselUpdate = function (event) {
      var picker = pickerForForm(form);
      var variant = variantFromPickerScript(picker);
      var mediaId =
        (event.detail &&
          event.detail.cell &&
          event.detail.cell.getAttribute('data-media-id')) ||
        featuredMediaIdForForm(form, variant);
      var index = event.detail && typeof event.detail.index === 'number' ? event.detail.index : -1;
      if (mediaId) syncThumbnailNavigation(gallery, mediaId, index);
    };
    ['carousel:change', 'carousel:settle', 'carousel:select'].forEach(function (evt) {
      carousel.addEventListener(evt, onCarouselUpdate);
    });
  }

  function syncProductGalleryMedia(form, variant) {
    syncDiamondMediaGallery(form, variant);
    syncStandardProductGallery(form, variant);
  }

  function dispatchProductRerender(form, html) {
    if (!form || !html) return;
    var fragment = document.createRange().createContextualFragment(html);
    form.dispatchEvent(
      new CustomEvent('product:rerender', {
        bubbles: true,
        detail: {
          htmlFragment: fragment,
          productChange: false
        }
      })
    );
  }

  function applyVariantCore(form, picker, variant) {
    if (!form || !variant || !variant.id) return;

    var input = variantIdInput(form);
    if (input) {
      input.value = String(variant.id);
      input.disabled = false;
    }

    if (picker) {
      var script = picker.querySelector('script[data-variant]');
      if (script) {
        script.textContent = JSON.stringify(variant);
      }
      if (picker.hasAttribute('update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({ path: url.toString() }, '', url.toString());
      }
    }
  }

  function applyVariant(form, picker, variant, previousVariant) {
    applyVariantCore(form, picker, variant);

    var changeEvent = new CustomEvent('variant:change', {
      bubbles: true,
      detail: {
        formId: form.id,
        variant: variant,
        previousVariant: previousVariant || null
      }
    });
    changeEvent.nvVariantSyncDispatch = true;
    form.dispatchEvent(changeEvent);

    var gallery = galleryForForm(form);
    if (gallery) {
      applyFilteredIndexes(gallery, gallery.getAttribute('filtered-indexes'), variant);
    }
    scheduleGallerySync(form, variant);
  }

  function parseSectionHtml(html, picker) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var formId = picker.getAttribute('form-id');
    var newPicker =
      doc.querySelector('variant-picker[form-id="' + formId + '"]') ||
      doc.querySelector('variant-picker');
    var script = newPicker && newPicker.querySelector('script[data-variant]');
    var variant = script ? JSON.parse(script.textContent || '{}') : null;
    var galleryMarkup =
      (formId && doc.querySelector('product-gallery[form="' + formId + '"]')) ||
      doc.querySelector('product-gallery');
    return { doc: doc, newPicker: newPicker, variant: variant, galleryMarkup: galleryMarkup, html: html };
  }

  function applySectionUpdates(form, picker, parsed, previousVariant) {
    if (!parsed || !parsed.variant) return;

    if (parsed.newPicker) {
      updatePickerLabels(picker, parsed.newPicker);
    }

    var liveGallery = galleryForForm(form);
    if (liveGallery && parsed.galleryMarkup) {
      applyFilteredIndexes(
        liveGallery,
        parsed.galleryMarkup.getAttribute('filtered-indexes'),
        parsed.variant
      );
    }

    applyVariantCore(form, picker, parsed.variant);
    dispatchProductRerender(form, parsed.html);

    var activePicker = pickerForForm(form) || picker;
    if (activePicker && parsed.newPicker) {
      updatePickerLabels(activePicker, parsed.newPicker);
    }

    scheduleGallerySync(form, parsed.variant);
  }

  function waitForUpdatedVariant(picker, previousId) {
    return new Promise(function (resolve) {
      var attempts = 0;
      function check() {
        var variant = variantFromPickerScript(picker);
        if (variant && variant.id && String(variant.id) !== String(previousId)) {
          resolve(variant);
          return;
        }
        if (attempts++ > 40) {
          resolve(variant || null);
          return;
        }
        requestAnimationFrame(check);
      }
      check();
    });
  }

  function buildSectionUrl(picker) {
    var optionValues = optionValueIds(picker);
    var handle = picker.getAttribute('handle');
    var sectionId = picker.getAttribute('section-id');
    var context = picker.getAttribute('context');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url =
      root +
      'products/' +
      encodeURIComponent(handle) +
      '?option_values=' +
      optionValues.join(',');

    if (context !== 'quick_buy' && sectionId) {
      url += '&section_id=' + encodeURIComponent(sectionId);
    }
    return { url: url, optionValues: optionValues };
  }

  function fetchVariantSection(picker) {
    var formId = picker.getAttribute('form-id');
    if (pendingByFormId.has(formId)) {
      return pendingByFormId.get(formId);
    }

    var built = buildSectionUrl(picker);
    if (!built.optionValues.length) {
      return Promise.resolve({
        variant: variantFromPickerScript(picker),
        html: null,
        newPicker: null,
        galleryMarkup: null
      });
    }

    var promise = fetch(built.url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var parsed = parseSectionHtml(html, picker);
        parsed.html = html;
        return parsed;
      })
      .catch(function () {
        return {
          variant: variantFromPickerScript(picker),
          html: null,
          newPicker: null,
          galleryMarkup: null
        };
      })
      .finally(function () {
        pendingByFormId.delete(formId);
      });

    pendingByFormId.set(formId, promise);
    return promise;
  }

  function tryThemeSelectCombination(picker) {
    if (typeof picker.selectCombination !== 'function') {
      return Promise.resolve(false);
    }
    var optionValues = optionValueIds(picker);
    if (!optionValues.length) {
      return Promise.resolve(false);
    }
    try {
      var result = picker.selectCombination({ optionValues: optionValues, productChange: false });
      if (result && typeof result.then === 'function') {
        return result.then(function () {
          return true;
        }).catch(function () {
          return false;
        });
      }
      return Promise.resolve(true);
    } catch (e) {
      return Promise.resolve(false);
    }
  }

  function syncPicker(picker) {
    var form = formForPicker(picker);
    if (!form || !picker) return Promise.resolve(null);

    var previousVariant = variantFromPickerScript(picker);

    return tryThemeSelectCombination(picker).then(function (themeHandled) {
      if (themeHandled) {
        return waitForUpdatedVariant(picker, previousVariant && previousVariant.id).then(function (current) {
          if (!current || !current.id) return current;
          applyVariantCore(form, picker, current);
          return refreshGalleryFilters(form, picker).then(function () {
            scheduleGallerySync(form, current);
            return current;
          });
        });
      }

      return fetchVariantSection(picker).then(function (parsed) {
        if (parsed && parsed.variant && parsed.variant.id) {
          applySectionUpdates(form, picker, parsed, previousVariant);
          return parsed.variant;
        }
        return null;
      });
    });
  }

  function onPickerInteraction(picker) {
    if (!picker) return;
    requestAnimationFrame(function () {
      syncPicker(picker);
    });
  }

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!target || !target.matches || !target.matches('input[data-option-position]')) return;
      var picker = target.closest('variant-picker[form-id]');
      if (picker) onPickerInteraction(picker);
    },
    false
  );

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest('label[for], .color-swatch, .block-swatch, .thumbnail-swatch')) return;
      var picker = event.target.closest('variant-picker[form-id]');
      if (picker) onPickerInteraction(picker);
    },
    true
  );

  document.addEventListener('variant:change', function (event) {
    var detail = event.detail || {};
    if (!detail.variant || !detail.formId) return;
    var form = document.getElementById(detail.formId);
    if (!form) return;
    if (event.nvVariantSyncDispatch) {
      return;
    }
    applyVariantCore(form, pickerForForm(form), detail.variant);
    var gallery = galleryForForm(form);
    if (gallery) {
      applyFilteredIndexes(gallery, gallery.getAttribute('filtered-indexes'), detail.variant);
    }
    scheduleGallerySync(form, detail.variant);
  });

  document.addEventListener('product:rerender', function (event) {
    var form = event.target;
    if (!form || !form.id || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var picker = pickerForForm(form);
    var fragment = event.detail && event.detail.htmlFragment;
    if (fragment) {
      var galleryMarkup =
        fragment.querySelector('product-gallery[form="' + form.id + '"]') ||
        fragment.querySelector('product-gallery');
      var liveGallery = galleryForForm(form);
      if (liveGallery && galleryMarkup) {
        applyFilteredIndexes(
          liveGallery,
          galleryMarkup.getAttribute('filtered-indexes'),
          variantFromPickerScript(picker)
        );
      }
    }
    var variant = variantFromPickerScript(picker);
    if (variant && variant.id) {
      scheduleGallerySync(form, variant);
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

    var picker = pickerForForm(form);
    var input = variantIdInput(form);

    if (!picker) {
      if (input) input.disabled = false;
      return;
    }

    var expected = variantFromPickerScript(picker);
    if (
      input &&
      expected &&
      expected.id &&
      String(input.value) === String(expected.id) &&
      !input.disabled
    ) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    syncPicker(picker).then(function (variant) {
      if (variant) {
        applyVariant(form, picker, variant, expected);
      }
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });
  }, true);

  function initPickers(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('variant-picker[form-id]').forEach(function (picker) {
      var form = formForPicker(picker);
      var variant = variantFromPickerScript(picker);
      if (form && variant && variant.id) {
        var input = variantIdInput(form);
        if (input) {
          input.disabled = false;
        }
        bindGalleryCarouselSync(form);
        var gallery = galleryForForm(form);
        if (gallery) {
          applyFilteredIndexes(gallery, gallery.getAttribute('filtered-indexes'), variant);
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPickers(document);
    });
  } else {
    initPickers(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initPickers(event.target);
  });
})();
